import axios from "axios";

export default {
    async setAuthUser({commit}) {
        try {
            const resp = await axios.get(`${window.env.MILESTONES_AUTH_HOST}/get-auth-user`);
            let authUser = {};
            if (resp?.data?.status === 200) {
                authUser = {
                    uuid: resp?.data?.data?.uuid,
                    email: resp?.data?.data?.email,
                };
                commit('SET_AUTH_USER', authUser);
            }
        } catch (e) {
            console.warn(e);
        }

    }
};